function Loader() {
    return <p className="message">בטעינה...</p>;
  }

  export default Loader;